<template>
  <div class="pagoda-text-cell" v-bind="$attrs">
    {{showContent}}
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    value: null,
    item: {
      type: Object,
      default: () => {}
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
  },
  methods: {
  },
  computed: {
    showContent() {
      if (this.item.hasOwnProperty('text') && this.item.text) return this.item.text
      else if (this.value || this.value === 0) return this.value
      else return '--'
    }
  }
}
</script>
